import React, { useState } from 'react';
import {
  Typography, TextField, Button, Alert, Container, Paper
} from '@mui/material';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../css/Login.css'; 
import API_BASE_URL from '../api';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/users/reset-password/${token}`, { password });
      setSuccess('Mot de passe réinitialisé avec succès.');
      setError('');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'Erreur lors de la réinitialisation du mot de passe.');
      setSuccess('');
    }
  };

  return (
    <div className="login-container">
      <Container maxWidth="sm">
        <Paper elevation={6} sx={{ padding: 4, mt: 8, borderRadius: 3 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Réinitialiser le mot de passe
          </Typography>

          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}

          <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
            <TextField
              type="password"
              label="Nouveau mot de passe"
              fullWidth
              margin="normal"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              type="password"
              label="Confirmer le mot de passe"
              fullWidth
              margin="normal"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
            >
              Réinitialiser le mot de passe
            </Button>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default ResetPassword;
